<template>
  <div>
    <div v-show="expanded" class="px-4 pt-2 border-t-2 border-gray-medium">
      <h4>Client Credentials</h4>
      <DataViewer :data="credentials" display="code" />
    </div>
    <div class="text-center">
      <a
        href="#!"
        class="underline-none text-gray-dark block"
        @click.prevent="expand"
        :title="expandTitle"
      >
        <i class="material-icons micon">{{ expandIcon }}</i>
      </a>
    </div>
  </div>
</template>

<script>
import DataViewer from '@/Common/DataViewer'
export default {
  name: 'AdvancedControls',
  components: {
    DataViewer,
  },
  props: {
    credentials: Object,
  },
  data() {
    return {
      expanded: false,
    }
  },
  computed: {
    expandIcon() {
      return this.expanded ? 'expand_less' : 'expand_more'
    },
    expandTitle() {
      return this.expanded ? 'Hide Advanced Controls' : 'Show Advanced Controls'
    },
  },
  methods: {
    expand() {
      this.expanded = !this.expanded
    },
  },
}
</script>

<style></style>
